import Column from "@/Components/Grid/Column";
import Container from "@/Components/Grid/Container";
import Row from "@/Components/Grid/Row";
import FrontText from "../FrontText";
import { Icon } from "@iconify/react";
import FrontSquareBeforeText from "../Partials/FrontSquareBeforeText";
import { useTranslation, Trans } from "react-i18next";
import makePhoneNumber from "@/Helpers/makePhoneNumber";
import WebpImage from "./WebpImage";

const FrontOurTeamCards = ({ heading, agents, classicHeading = false }) => {
    const { t, i18n } = useTranslation();
    if (!heading) {
        if (agents.length === 1) {
            heading = t('general.contactPerson');
        } else {
            heading = t('general.contactPersons');
        }
    }

    const currentLang = i18n.resolvedLanguage;
    if (agents.length > 0) {
        return (
            <Container>
                <Row>
                    <Column>
                        {!classicHeading ? 
                            <FrontSquareBeforeText className="mb-10">
                                {heading}
                            </FrontSquareBeforeText>
                        :
                        <p>123</p>
                    }
                    </Column>
                </Row>
                <Row className="justify-between lg:gap-y-20 md:gap-y-15 gap-y-10">
                    {agents.map((el, index) => (
                        <Column xl={5} lg={6} md={12} key={index}>
                            <div className="flex max-w-full h-full shadow-28px rounded-20">
                                <div className="image-wrapper md:w-50 w-32 min-w-[120px] h-full sm:shrink-0">

                                <WebpImage
                                    lazy={true}
                                    className="w-full h-full rounded-l-20 object-cover"
                                    sources={[
                                        {
                                            width: 1,
                                            path: `/storage/avatars/${el.photo.substring(0, el.photo.lastIndexOf('.'))}-400`,
                                            mime: el.photo.split('.').pop(),
                                        },
                                    ]}
                                    alt={el.name + ' - ' + (currentLang === 'pl' ? el.position : el.position_en)}
                                    fallback={`/storage/avatars/${el.photo}`}
                                    seo={{
                                        width: 200,
                                        height: 200,
                                    }}
                                />

                                </div>

                                <div className="content-wrapper md:py-6 py-3 md:px-5 px-2 bg-dark-blue-standard w-full max-w-full h-full rounded-r-20">
                                    <FrontText
                                        textSize={"20/29-m-14/20"}
                                        className="text-white font-bold"
                                    >
                                        {el.name}
                                    </FrontText>
                                    <FrontText
                                        textSize={"14/20-m-8/12"}
                                        className="text-yellow font-medium"
                                    >
                                        {currentLang === 'pl' && el.position}
                                        {currentLang === 'en' && el.position_en}
                                    </FrontText>

                                    <div className="mt-c22 text-white">
                                        <a
                                            href={`mailto:${el.email}?bcc=marketingleads@savills.pl`}
                                            className="mb-3 hover:text-yellow hover:border-yellow items-center transition-all ease-in-out duration-300 flex gap-c6"
                                        >
                                            <Icon
                                                className="shrink-0 p-1 border sm:w-7 sm:h-7 w-6 h-6 border-inherit rounded-full"
                                                icon="material-symbols:mail-outline-rounded"
                                                height={28}
                                                width={28}
                                            />
                                            <FrontText textSize="14/20-m-10/14">
                                                <span className="overflow-wrap-anywhere">{el.email}</span>
                                            </FrontText>
                                        </a>

                                        <a
                                            href={makePhoneNumber(el.phone)}
                                            className="mb-3 hover:text-yellow hover:border-yellow items-center transition-all ease-in-out duration-300 flex gap-c6"
                                        >
                                            <Icon
                                                className="shrink-0 p-1 border sm:w-7 sm:h-7 w-6 h-6 border-inherit rounded-full"
                                                icon="ic:baseline-phone"
                                                height={28}
                                                width={28}
                                            />
                                            <FrontText textSize="14/20-m-10/14">
                                                {el.phone}
                                            </FrontText>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </Column>
                    ))}
                </Row>
            </Container>
        );
    }
};

export default FrontOurTeamCards;
